<template>
<div class="all-detail-task">
    <div @mouseenter="hoverCurrent=index" @mouseleave="hoverCurrent=-1" class=" progress-box-height" :class="[taskDatas.length>8?'progress-box-overflow':'progress-box',item.open&&item.itemProgressInfo?'progress-failed-more':'',item.open&&!item.itemProgressInfo?'progress-failed-less':'']" v-for="(item, index) in taskDatas" :key="index" @click="collapse(index,item)">
        <div class="detailed-progress-box">
        </div>
        <div class="task-info">
            <div class="task-info-name">
                <div class="task-status-name status-grey" v-if="item.status==3">{{$t('language.common.canceled')}}:</div>
                <div class="task-status-name status-blue" v-if="getTaskStr(item)=='success8'">{{$t('language.common.partialSuccess')}}:</div>
                <div class="task-status-name status-grey" v-if="getTaskStr(item)=='error'">{{$t('language.common.failure')}}:</div>
                <div :title="item.sourceFilename" class="detailed-sources-name">&nbsp;{{item.sourceFilename}}</div>
            </div>
            <div class="task-info-percent"></div>
            <div class="task-info-speed" v-if="hoverCurrent==index">
                <div class="icon-util taskinfo-collapse-position" :class="item.open?'collapse-up':'collapse-down'"></div>
            </div>
            <unfinishedDetail :open=item.open :index=index :itemDetail='item'></unfinishedDetail>
        </div>
    </div>
</div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import unfinishedDetail from '@/components/common/tabs/tabs_detailed_progress/tab_unfinished_detail';
export default {
    components: {
        unfinishedDetail
    },
    watch:{
      '$store.state.detailTabUnfinished':function(newValue,oldValue){
          this.taskDatas=newValue;
      }
    },
    data: function () {
        return {
            statusColor: "",
            clickCurrent: -1,
            hoverCurrent: -1,
            taskDatas: []
        };
    },
    methods: {
        // 获取任务标识
        getTaskStr(item) {
            return commonUtils.getTaskStr(item);
        },
          collapse(index, item) {
            if (item.open) {
                item.open=false;
                this.$forceUpdate();
            } else {
               item.open=true;
               this.$forceUpdate();
               $.each(this.taskDatas,function(j,jItem){
                    if(item.taskId!=jItem.taskId&&jItem.open){
                        jItem.open=false;
                    }
               });
            }
        },
    }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/common/tabs/tabs_detailed_progress/tab_unfinished_tasks.vue